import { Box } from '@chakra-ui/react';

import VarianceWrapper from '../../variance/VarianceWrapper';

import { BaseInstrumentProperties } from './proptypes';

export const VarianceInstrument = ({ widget, output }: BaseInstrumentProperties) => {
  const buildVarianceOutput = (outputData: any) => ({
    ...outputData,
    data: output?.data?.map((item: any, index: number) => ({
      ...item,
      indicator: outputData.instrument_indicators[index],
    })),
  });

  return (
    <Box height='100%' width='100%'>
      <VarianceWrapper
        output={buildVarianceOutput(widget)}
        columnSettings={widget?.formatting?.columns_settings}
        columnPositions={widget?.formatting?.columns_position}
      />
    </Box>
  );
};

export default VarianceInstrument;
